import { FlightState, TypeFare, TypeFlight } from "@/lib/redux/features/flight/type"

const normalizeAirlineCode = (code?: string) => code?.replace(/^_/, "") || ""

export const getDisplayedAirlineCode = (
  _state: FlightState,
  flight: TypeFlight,
  fareData?: TypeFare,
) => {
  const firstSegment = flight.segments[0]
  const marketingAirline = normalizeAirlineCode(firstSegment?.airline)
  const operatingAirline = normalizeAirlineCode(firstSegment?.operatingAirline)
  const fareAirline = normalizeAirlineCode(fareData?.system)

  return marketingAirline || operatingAirline || fareAirline
}